import { z } from 'zod';
import { LANGS } from '../i18n.js';
import { phoneSchema } from './common.js';
/**
 * Telefon raqamini SMS orqali tasdiqlash.
 *
 * BT'da bu yo'q edi — mijoz qaroriga ko'ra qo'shildi: SMS tasdiqlash
 * kerak bo'lgan hamma joyda o'z kodimizni yuboramiz (Eskiz orqali).
 * Birinchi qo'llanishi — MyID'dan oldin raqamni tasdiqlash.
 *
 * Provayderlar (Alif, Uzum) o'z OTP'larini alohida yuboradi — ular bilan
 * aralashtirmaslik kerak.
 */
export const sendOtpRequestSchema = z.object({
    phone: phoneSchema,
    /**
     * SMS tili — **mijozning** tili, sotuvchi anketada tanlaydi.
     * Interfeys tilidan farq qilishi mumkin: sotuvchi o'zbekcha ishlab,
     * ruszabon mijozga ruscha SMS yuborishi mumkin.
     */
    lang: z.enum(LANGS).optional(),
});
export const sendOtpResponseSchema = z.object({
    /** Maskalangan raqam — sotuvchiga qayerga yuborilganini ko'rsatish uchun. */
    phoneMasked: z.string(),
    /** Kod necha soniyadan keyin eskiradi. */
    expiresInSec: z.number().int().positive(),
    /** Qolgan urinishlar soni. */
    maxAttempts: z.number().int().positive(),
    /**
     * Kodni qayta yuborishdan oldin qancha kutish kerak, soniya.
     * Ekranda hisoblagich ko'rsatiladi — tugmani ketma-ket bosish
     * mijozga ortiqcha SMS yuboradi va pul sarflaydi.
     */
    resendAfterSec: z.number().int().nonnegative(),
    /** Shu raqamga bugun yana nechta kod yuborish mumkin. */
    sendsLeft: z.number().int().nonnegative(),
    /**
     * FAQAT `mock` rejimda to'ladi — SMS haqiqatda yuborilmaydi, shuning
     * uchun kodni ekranda ko'rsatamiz. Real rejimda hech qachon qaytmaydi.
     */
    mockCode: z.string().optional(),
});
export const verifyOtpRequestSchema = z.object({
    phone: phoneSchema,
    code: z.string().regex(/^\d{6}$/, 'v.otpCode'),
});
export const verifyOtpResponseSchema = z.object({
    verified: z.literal(true),
    /**
     * Tasdiqlangan raqam uchun belgi. Anketa yuborilganda shu bilan birga
     * keladi — backend raqam haqiqatan tasdiqlanganini shu orqali biladi.
     */
    token: z.string(),
});
//# sourceMappingURL=otp.js.map